"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const colors_1 = __importDefault(require("../../../../styles/colors"));
const icon_1 = __importDefault(require("../../../icon/icon"));
const styles_1 = __importDefault(require("../../../../styles/styles"));
const pressable_1 = __importDefault(require("../../../pressable/pressable"));
const eventConstants_1 = require("../../../../constants/eventConstants");
const CallConnecting = ({ endCall }) => (react_1.default.createElement(react_native_1.View, null,
    react_1.default.createElement(react_native_1.View, { style: styles_1.default.yellowLabel },
        react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.marginTen, styles_1.default.textColorBlack] }, `Connecting... `)),
    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginTen, styles_1.default.alignCenterCenter] },
        react_1.default.createElement(pressable_1.default, { style: [styles_1.default.flexOne, styles_1.default.marginTen, styles_1.default.roundedIconContainer], onPress: endCall, eventName: eventConstants_1.END_CALL_CONNECTING },
            react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faPhone, color: colors_1.default.RED, size: 28 })))));
exports.default = CallConnecting;
